// import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom"; // Import NavLink for routing
// import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom"; // Importing RouterLink for routing
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import logo from "../../Assets/Logo/navbarLogo.svg";
// import icons from "../../icons.config";
// import { useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { removeLikedItem, clearAll } from "../../store/likedItemsSlice";
// import GlobalButton from "../GlobalButton";

// const Navbar = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false); // State to track the nav visibility
//   const [isSliderOpen, setIsSliderOpen] = useState(false); // Slider state
//   const [isCartSliderOpen, setIsCartSliderOpen] = useState(false); // Slider state
//   const likedItems = useSelector((state) => state.likedItems); // Get liked items from Redux store
//   const dispatch = useDispatch(); // Dispatch for Redux actions

//   const navLinks = [
//     { name: "SHOP", id: "shop", path: "/shop" }, // Adding path for routing
//     { name: "BLOGS", id: "blogs", path: "/blogs" }, // Add path for the Blogs section
//     { name: "ABOUT US", id: "aboutus", path: "/aboutus" }, // Add path for About Us section
//     { name: "CONTACT US", id: "contactus", path: "/contact" }, // Add path for Contact Us section
//   ];

//   const navigate = useNavigate();
//   const location = useLocation();

//   const toggleNav = () => {
//     setIsNavOpen((prev) => !prev); // Toggle the nav visibility
//   };

//   // Function to scroll to top whenever location (route) changes
//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to top of the page
//   }, [location]);

//   const toggleSlider = () => {
//     setIsSliderOpen(!isSliderOpen);
//   };
//   const toggleCartSlider = () => {
//     setIsCartSliderOpen(!isCartSliderOpen);
//   };

//   const handleDeleteClick = (id) => {
//     console.log("Deleting item with ID:", id); // Log ID
//     dispatch(removeLikedItem({ id })); // Dispatch the removeLikedItem action
//   };
//   const handleClearAll = () => {
//     dispatch(clearAll()); // Add a corresponding case in your reducer
//   };

//   return (
//     <div className="fixed top-0 w-full h-[70px] md:h-[85px] bg-primary2 text-primary1 font-outfit p-4 z-50">
//       <div className="flex justify-between items-center h-full px-7">
//         {/* Navigation links for larger screens */}
//         <ul className="hidden lg:flex lg:pl-1 xl:pl-12 space-x-8 mx-10">
//           {navLinks.map((link, index) => (
//             <li key={index} className="cursor-pointer flex text-sm">
//               <NavLink
//                 to={link.path}
//                 className={({ isActive }) =>
//                   `pb-2 ${
//                     isActive ? "font-semibold text-hcolor" : "hover:text-hcolor"
//                   }`
//                 } // Conditionally apply semibold and text-hcolor when active
//               >
//                 {link.name}
//               </NavLink>
//             </li>
//           ))}
//         </ul>

//         {/* Hamburger and heart icon for smaller screens */}
//         <div className="lg:hidden flex items-center relative left-[-5]">
//           <div
//             onClick={toggleNav}
//             className="cursor-pointer md:text-xl font-extralight text-md text-primary1"
//           >
//             {
//               isNavOpen ? (
//                 <FontAwesomeIcon icon={faTimes} className="font-light" /> // Display faTimes icon when nav is open
//               ) : (
//                 <img
//                   src={icons.bars}
//                   alt="bars"
//                   className="font-normal h-9 w-9 -ml-1 "
//                 />
//               ) // Display bars image when nav is closed
//             }
//           </div>
//           {/* <div className="ml-2 md:ml-7 mr-4 md:mr-0 cursor-pointer">
//             <img src={icons.heart} alt="liked" className='w-7 h-8' />
//           </div> */}
//           <div
//             onClick={toggleSlider}
//             className="cursor-pointer md:text-xl font-extralight text-md text-primary1"
//           >
//             {isSliderOpen ? (
//               ""
//             ) : (
//               <>
//                 <img src={icons.heart} alt="liked" className="w-6 h-7" />
//                 {likedItems.length >= 0 && (
//                   <span className="absolute top-1 -right-2 bg-hcolor text-tertiary text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
//                     {likedItems.length}
//                   </span>
//                 )}
//               </>
//             )}
//           </div>
//         </div>

//         <div className="flex relative left-8 md:left-7">
//           <img
//             src={logo}
//             alt="logo"
//             className="w-[120px] h-[100px] md:w-[160px] md:h-[140px] lg:w-[200px] lg:h-[180px] xl:w-[200px] xl:h-[200px] relative lg:right-24 xl:right-32 cursor-pointer"
//             onClick={() => navigate("/")}
//           />
//         </div>

//         <div className="flex justify-end space-x-7 left-4 md:pr-[-20px] lg:pr-[50px] xl:pr-[90px] relative top-1">
//           <div
//             onClick={toggleSlider}
//             className="ml-2 md:ml-7 mr-4 md:mr-1 cursor-pointer hidden lg:flex relative"
//           >
//             {isSliderOpen ? (
//               ""
//             ) : (
//               <>
//                 <img src={icons.heart} alt="liked" className="w-6 h-7" />
//                 {likedItems.length >= 0 && (
//                   <span className="absolute -top-0 -right-2 bg-hcolor text-tertiary text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
//                     {likedItems.length}
//                   </span>
//                 )}
//               </>
//             )}
//           </div>

//           <div
//             onClick={toggleCartSlider}
//             className="z-10 text-md md:space-x-0 relative left-5 md:left-0"
//           >
//             {isCartSliderOpen ? (
//               ""
//             ) : (
//               <img
//                 src={icons.bag}
//                 alt="shopping cart"
//                 className="h-[90%] md:h-[70%] text-primary1"
//               />
//             )}
//           </div>
//           <div
//             className="z-10 text-xl space-x-0 cursor-pointer"
//             onClick={() => navigate("/signup")}
//           >
//             <img
//               src={icons.user}
//               alt="user"
//               className="h-[90%] md:h-[70%] text-primary1"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Navigation links for smaller screens */}
//       <div
//         className={`fixed left-0 top-0 w-[62%] h-[70%] text-primary1 bg-primary2 transition-transform duration-300 ease-in-out shadow-lg ${
//           isNavOpen ? "translate-x-0" : "-translate-x-full"
//         } lg:hidden flex flex-col items-start`}
//       >
//         {/* Close Icon */}
//         <div className="self-end p-4 cursor-pointer" onClick={toggleNav}>
//           <FontAwesomeIcon icon={faTimes} className="text-xl" />
//         </div>

//         <ul className="flex flex-col items-start space-y-5 p-4 mt-9">
//           {navLinks.map((link, index) => (
//             <li key={index} className="cursor-pointer">
//               <NavLink
//                 to={link.path}
//                 onClick={toggleNav}
//                 className={({ isActive }) =>
//                   `text-lg ${
//                     isActive ? "font-semibold text-hcolor" : "hover:text-hcolor"
//                   }`
//                 } // Conditionally apply semibold and text-hcolor when active
//               >
//                 {link.name}
//               </NavLink>
//             </li>
//           ))}
//         </ul>
//       </div>
// {isSliderOpen && (
//   <div className="slider-container fixed top-0 right-0 w-[50%] lg:w-1/3 h-full bg-tertiary shadow-lg z-50 transition-transform duration-300 ease-in-out ">
//     <div className=" p-4 flex justify-end items-end">
//       <FontAwesomeIcon
//         icon={faTimes}
//         className="cursor-pointer text-primary1 "
//         onClick={toggleSlider}
//       />
//     </div>
//     {/* Render liked items */}
//     <div className="">
//       {likedItems.length > 0 ? (
//         <div className="px-7">
//           {/* Favourites Heading and Clear All Button */}
//           <div className="flex items-center mb-4 ">
//             <h2 className="text-lg font-outfit text-hcolor relative bottom-8">
//               Favourites({likedItems.length})
//             </h2>
//             <button
//               className="text-sm text-red-500 font-medium underline relative right-24"
//               onClick={handleClearAll}
//             >
//               Clear All
//             </button>
//           </div>

//           {/* Liked Items List */}
//           {likedItems.map((item) => (
//             <div key={item.id} className="flex gap-4 mb-4">
//               <img
//                 src={item.thumbnail}
//                 alt={item.title}
//                 className="w-[50%] h-[50%] lg:w-1/6 lg:h-1/6 object-cover"
//               />
//               <div className="flex flex-col items-start">
//                 <p className="font-outfit font-light text-xl text-left">
//                   {item.title.toUpperCase()}
//                 </p>
//                 <p className="text-xs text-gray-500 text-left">
//                   {item.price}
//                 </p>
//               </div>
//               <button
//                 className="text-red-500 text-sm"
//                 onClick={() => handleDeleteClick(item.id)}
//               >
//                 Delete
//               </button>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className=" relative top-[250px] space-y-4">
//           <div className=" flex items-center justify-center">
//             <img src={icons.noItemLiked} className="w-[20%]" />
//           </div>
//           <p className="text-center text-hcolor ">No liked items yet!</p>
//           <div className=" flex items-center justify-center">
//             <button className="border-2 py-2 px-5 flex text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 bg-tertiary transition-all duration-500 ease-in-out">
//               <GlobalButton label="EXPLORE" routeName="shop" />
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   </div>
// )}
//       {isCartSliderOpen && (
//         <div className="slider-container fixed top-0 right-0 w-[50%] lg:w-1/3 h-full bg-secondary shadow-lg z-50 transition-transform duration-300 ease-in-out">
//           <div className="flex justify-between items-center p-4">
//             <h2 className="text-lg font-bold">Your Cart Items</h2>
//             <FontAwesomeIcon
//               icon={faTimes}
//               className="cursor-pointer text-primary1"
//               onClick={toggleCartSlider}
//             />
//           </div>
//           {/* Render liked items */}
//           <div className="">
//             {likedItems.length > 0 ? (
//               likedItems.map((item) => (
//                 <div
//                   key={item.id}
//                   className="flex items-center gap-4 mb-4 w-60"
//                 >
//                   <img
//                     src={item.image}
//                     alt={item.title}
//                     className=" object-cover "
//                   />
//                   <div>
//                     <p className="font-medium text-sm">{item.title}</p>
//                     <p className="text-xs text-gray-500">{item.price}</p>
//                   </div>
//                   <button
//                     className="text-red-500 text-sm"
//                     onClick={() => handleDeleteClick(item.id)}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               ))
//             ) : (
//               <p className="text-center text-gray-500">
//                 No items in the cart yet!
//               </p>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import logo from "../../Assets/Logo/navbarLogo.svg";
import icons from "../../icons.config";
import { useSelector } from "react-redux";
import LikedItemsSlider from "./likedItemsSlider";
import CartSlider from "./cartSlider";
import { useDispatch } from "react-redux";
import { logout } from "../../store/authSlice"; // Import logout action



const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [isCartSliderOpen, setIsCartSliderOpen] = useState(false);
 
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { name: "SHOP", id: "shop", path: "/shop" },
    { name: "BLOGS", id: "blogs", path: "/blogs" },
    { name: "ABOUT US", id: "aboutus", path: "/aboutus" },
    { name: "CONTACT US", id: "contactus", path: "/contact" },
  ];
  const likedItems = useSelector((state) => state.favourites);
 
    const cartItems = useSelector((state) => state.cartItems?.cartItems || []);
  
  const toggleNav = () => {
    setIsNavOpen((prev) => !prev);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const toggleSlider = () => {
    setIsSliderOpen(!isSliderOpen);
  };

  const toggleCartSlider = () => {
    setIsCartSliderOpen(!isCartSliderOpen);
  };
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  return (
    <div className="fixed top-0 w-full h-[70px] md:h-[85px] bg-primary2 text-primary1 font-outfit p-4 z-50">
      <div className="flex justify-between items-center h-full px-7">
        <ul className="hidden lg:flex lg:pl-1 xl:pl-12 space-x-8 mx-10">
          {navLinks.map((link, index) => (
            <li key={index} className="cursor-pointer flex text-sm">
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `pb-2 ${
                    isActive ? "font-semibold text-hcolor" : "hover:text-hcolor"
                  }`
                }
              >
                {link.name}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="lg:hidden flex items-center relative left-[-5]">
          <div
            onClick={toggleNav}
            className="cursor-pointer md:text-xl font-extralight text-md text-primary1"
          >
            {isNavOpen ? (
              <FontAwesomeIcon icon={faTimes} className="font-light" />
            ) : (
              <img
                src={icons.bars}
                alt="bars"
                className="font-normal h-9 w-9 -ml-1 "
              />
            )}
          </div>
          <div
            onClick={toggleSlider}
            className="cursor-pointer md:text-xl font-extralight text-md text-primary1"
          >
            {isSliderOpen ? (
              ""
            ) : (
              <>
                <img src={icons.heart} alt="liked" className="w-6 h-7" />
                {likedItems.length >= 0 && (
                  <span className="absolute top-1 -right-2 bg-hcolor text-tertiary text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
                    {likedItems.length}
                  </span>
                )}
              </>
            )}
          </div>
        </div>

        <div className="flex relative left-8 md:left-7">
          <img
            src={logo}
            alt="logo"
            className="w-[120px] h-[100px] md:w-[160px] md:h-[140px] lg:w-[200px] lg:h-[180px] xl:w-[200px] xl:h-[200px] relative lg:right-24 xl:right-32 cursor-pointer"
            onClick={() => navigate("/")}
          />
        </div>

        <div className="flex justify-end space-x-7 left-4 md:pr-[-20px] lg:pr-[50px] xl:pr-[90px] relative top-1">
          <div
            onClick={toggleSlider}
            className="ml-2 md:ml-7 mr-4 md:mr-1 cursor-pointer hidden lg:flex relative"
          >
            {isSliderOpen ? (
              ""
            ) : (
              <>
                <img src={icons.heart} alt="liked" className="w-6 h-7" />
                {likedItems.length >= 0 && (
                  <span className="absolute -top-0 -right-2 bg-hcolor text-tertiary text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
                    {likedItems.length}
                  </span>
                )}
              </>
            )}
          </div>

          <div
            onClick={toggleCartSlider}
            className="z-10 text-md md:space-x-0 relative left-5 md:left-0"
          >
            {isCartSliderOpen ? (
              ""
            // ) : (
            //   <img
            //     src={icons.bag}
            //     alt="shopping cart"
            //     className="h-[90%] md:h-[70%] text-primary1"
            //   />
            // )}
             ): (
              <>
                <img src={icons.bag} alt="shopping cart" className="w-6 h-7" />
                {cartItems.length >= 0 && (
                  <span className="absolute -top-0 -right-1 bg-hcolor text-tertiary text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
                    {cartItems.length}
                  </span>
                )}
              </>
            )}
          </div>
          <div
            className="z-10 text-xl space-x-0 cursor-pointer"
            onClick={() => navigate(isLoggedIn ? "/profile" : "/signup")}
          >
            <img
              src={icons.user}
              alt="user"
              className="h-[75%] md:h-[70%] text-primary1"
            />
          </div>
        </div>
      </div>

      <div
        className={`fixed left-0 top-0 w-[62%] h-[70%] text-primary1 bg-primary2 transition-transform duration-300 ease-in-out shadow-lg ${
          isNavOpen ? "translate-x-0" : "-translate-x-full"
        } lg:hidden flex flex-col items-start`}
      >
        <div className="self-end p-4 cursor-pointer" onClick={toggleNav}>
          <FontAwesomeIcon icon={faTimes} className="text-xl" />
        </div>

        <ul className="flex flex-col items-start space-y-5 p-4 mt-9">
          {navLinks.map((link, index) => (
            <li key={index} className="cursor-pointer">
              <NavLink
                to={link.path}
                onClick={toggleNav}
                className={({ isActive }) =>
                  `text-lg ${
                    isActive ? "font-semibold text-hcolor" : "hover:text-hcolor"
                  }`
                }
              >
                {link.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
      {isSliderOpen && (
  <LikedItemsSlider likedItems={likedItems} toggleSlider={toggleSlider} />
)}


      {isCartSliderOpen && <CartSlider cartItems={cartItems} toggleCartSlider={toggleCartSlider} />}
    </div>
  );
};

export default Navbar;
